import { render, staticRenderFns } from "./CourseSelector.vue?vue&type=template&id=68dae46e&scoped=true"
import script from "./CourseSelector.vue?vue&type=script&lang=js"
export * from "./CourseSelector.vue?vue&type=script&lang=js"
import style0 from "./CourseSelector.vue?vue&type=style&index=0&id=68dae46e&prod&lang=scss&scoped=true"
import style1 from "./CourseSelector.vue?vue&type=style&index=1&id=68dae46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dae46e",
  null
  
)

export default component.exports